<template>
  <div>
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('fixDutyFine.reportedEvent')"
      :visible.sync="addDialog"
      top="5vh"
      @close="resetForm('ruleForm')"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <!--   事件类型     -->
            <el-form-item :label="$t('fixDutyFine.eventCategory')" prop="eventType">
              <el-select
                v-model="ruleForm.eventType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                @change="changeEventType"
              >
                <el-option key="1" :label="$t('fixDutyFine.abnormalEvent')" :value="1" />
                <el-option key="2" :label="$t('fixDutyFine.theftEvent')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--    异常类型      -->
            <el-form-item :label="$t('fixDutyFine.abnormalityType')" prop="exceptionType">
              <el-select
                v-model="ruleForm.exceptionType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in exceptionTypeList"
                  :key="item.type"
                  :label="item.typeName"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--    异常等级   -->
            <el-form-item :label="$t('fixDutyFine.abnormalityLevel')" prop="exceptionLevel">
              <el-select
                v-model="ruleForm.exceptionLevel"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('fixDutyFine.high')" :value="1" />
                <el-option key="2" :label="$t('fixDutyFine.medium')" :value="2" />
                <el-option key="3" :label="$t('fixDutyFine.low')" :value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--  预估资金损失   -->
            <el-form-item :label="$t('fixDutyFine.estimatedLossAmount')" prop="financeLoss">
              <el-input
                v-model="ruleForm.financeLoss"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--  影响包裹明细   -->
            <el-form-item :label="$t('fixDutyFine.affectedPackageDetails')" prop="packageDetail">
              <el-input
                v-model="ruleForm.packageDetail"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                :rows="3"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--  异常事件描述  -->
            <el-form-item :label="$t('fixDutyFine.abnormalityDescription')" prop="exceptionDetail">
              <el-input
                v-model="ruleForm.exceptionDetail"
                :maxlength="1000"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                :rows="3"
                show-word-limit
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--  伤亡人员数量   -->
            <el-form-item :label="$t('fixDutyFine.casualtyCount')" prop="lossPeopleQuantity">
              <el-input
                v-model="ruleForm.lossPeopleQuantity"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                clearable
                maxlength="9"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.eventType === 2" :span="12">
            <el-form-item :label="$t('fixDutyFine.hasMDFE')" prop="mdfeInvoice">
              <el-select
                v-model="ruleForm.mdfeInvoice"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('GlobalSetObj.yes')" :value="1" />
                <el-option key="2" :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.eventType === 2" :span="12">
            <el-form-item :label="$t('fixDutyFine.hasPoliceReceipt')" prop="policeReceipt">
              <el-select
                v-model="ruleForm.policeReceipt"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('GlobalSetObj.yes')" :value="1" />
                <el-option key="2" :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="ruleForm.eventType === 2" :span="12">
            <el-form-item :label="$t('fixDutyFine.hasElectronicLock')" prop="electronicLock">
              <el-select
                v-model="ruleForm.electronicLock"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('GlobalSetObj.yes')" :value="1" />
                <el-option key="2" :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('fixDutyFine.addPhotos')" prop="photograph">
              <el-upload
                ref="uploadRef"
                v-model="ruleForm.photograph"
                :before-upload="beforeAvatarUpload"
                :file-list="imageList"
                :http-request="upLoad"
                :limit="6"
                :on-change="handleChangeFile"
                :on-exceed="handleExceed"
                :on-remove="handleDeleteImgRemove"
                action="#"
                list-type="picture-card"
                multiple
              >
                <i class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
            </el-form-item>
            <div style="color: #606266">
              {{ $t('fixDutyFine.uploadImageLimit') }}
            </div>
          </el-col>
          <el-col :span="24">
            <div style="text-align: right">
              <el-button @click="resetForm('ruleForm')">{{ $t('roleManage.cancel') }}</el-button>
              <el-button
                :loading="loadingBtn" type="primary" @click="submitForm('ruleForm')"
              >{{ $t('roleManage.confirm') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { vehicleTagNumber } from '@/api/orderApi';
import { uploadOos } from '@/utils/ali_oos_util';
import { modifyExceptionReport } from '@/api/bulkExpressApi';
import { checkValidPeople, enterValidPrice2 } from '@/utils/validate';

export default {
  props: {
    exceptionTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      addDialog: false,
      ruleForm: {
        eventType: '', // 事件类型  1-异常事件,2-盗抢事件
        exceptionType: '', // 异常类型  见异常类型下拉框接口
        exceptionLevel: '', // 异常等级  1-高,2-中,3-低
        financeLoss: '', // 预估资金损失
        lossPeopleQuantity: '', // 伤亡人员数量
        packageDetail: '', // 影响包裹明细
        exceptionDetail: '', // 异常事件描述
        policeReceipt: '', // 是否有报警回执  0否  1是
        mdfeInvoice: '', // 是否开具MDFE  0否  1是
        electronicLock: '', // 是否有电子锁  0否  1是
        photograph: ''
      },
      rules: {
        photograph: [],
        policeReceipt: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        mdfeInvoice: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        electronicLock: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        eventType: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        exceptionType: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        exceptionLevel: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        financeLoss: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          },
          {
            validator: enterValidPrice2,
            trigger: ['blur', 'change']
          }
        ],
        lossPeopleQuantity: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          },
          {
            validator: checkValidPeople,
            trigger: ['blur', 'change']
          }
        ],
        packageDetail: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        exceptionDetail: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ]
      },
      vehicleNumberList: [],
      pictureList: [],
      imageList: [],
      showImg: true,
      editId: null,
      loadingBtn: false,
      uploadingCount: 0 // 跟踪正在上传的文件数量
    };
  },
  methods: {
    // 切换事件类型
    changeEventType(arg) {
      console.log('arg', arg);
      this.rules.photograph = [];
      if (arg === 2) {
        this.rules.photograph.push({
          required: true,
          message: this.$t('fixDutyFine.uploadImages'),
          trigger: ['blur', 'change']
        });
      } else {
        this.rules.photograph.push({
          required: false,
          message: this.$t('fixDutyFine.uploadImages'),
          trigger: ['blur', 'change']
        });
      }
    },
    // 加载弹框
    showEventDialog(arg) {
      console.log(arg);
      this.imageList = [];
      this.pictureList = [];
      if (arg) {
        this.editId = arg.id;
        this.ruleForm = {
          eventType: arg.eventType,
          exceptionType: arg.exceptionType,
          exceptionLevel: arg.exceptionLevel,
          financeLoss: arg.financeLoss,
          lossPeopleQuantity: arg.lossPeopleQuantity,
          waybillNumberList: [], // 影响包裹明细
          exceptionDetail: arg.exceptionDetail,
          policeReceipt: arg.policeReceipt,
          mdfeInvoice: arg.mdfeInvoice,
          electronicLock: arg.electronicLock,
          photograph: '',
          packageDetail: arg.waybillNumberList ? arg.waybillNumberList.join('\n') : ''
        };
        if (arg.photoList && arg.photoList.length) {
          arg.photoList.forEach((item, index) => {
            const obj = {
              uid: index,
              url: item
            };
            this.imageList.push(obj);
            this.pictureList.push(obj);
          });
          this.ruleForm.photograph = this.imageList[0].url;
        }
      } else {
        this.editId = null;
      }
      this.addDialog = true;
      this.getVehicleNumber('');
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            eventType: this.ruleForm.eventType,
            exceptionType: this.ruleForm.exceptionType,
            exceptionLevel: this.ruleForm.exceptionLevel,
            financeLoss: this.ruleForm.financeLoss,
            lossPeopleQuantity: this.ruleForm.lossPeopleQuantity,
            waybillNumberList: [], // 影响包裹明细
            exceptionDetail: this.ruleForm.exceptionDetail,
            policeReceipt: '',
            mdfeInvoice: '',
            electronicLock: '',
            photoList: []
          };
          if (this.ruleForm.eventType === 2) {
            data.policeReceipt = this.ruleForm.policeReceipt;
            data.mdfeInvoice = this.ruleForm.mdfeInvoice;
            data.electronicLock = this.ruleForm.electronicLock;
          }
          if (this.ruleForm.packageDetail) {
            data.waybillNumberList = this.ruleForm.packageDetail.split('\n');
          }
          if (this.editId) {
            data.id = this.editId;
          }
          if (this.pictureList.length > 0) {
            data.photoList = this.pictureList.map((item) => item.url);
          }
          modifyExceptionReport(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.$refs[formName].resetFields();
              this.addDialog = false;
              this.$emit('search');
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {
        eventType: '', // 事件类型  1-异常事件,2-盗抢事件
        exceptionType: '', // 异常类型  见异常类型下拉框接口
        exceptionLevel: '', // 异常等级  1-高,2-中,3-低
        financeLoss: '', // 预估资金损失
        lossPeopleQuantity: '', // 伤亡人员数量
        packageDetail: '', // 影响包裹明细
        exceptionDetail: '', // 异常事件描述
        policeReceipt: '', // 是否有报警回执  0否  1是
        mdfeInvoice: '', // 是否开具MDFE  0否  1是
        electronicLock: '', // 是否有电子锁  0否  1是
        photograph: ''
      };
      this.$refs[formName].resetFields();
      this.imageList = [];
      this.pictureList = [];
      this.addDialog = false;
    },
    // 上传图片
    async upLoad(option) {
      const files = option.file;
      try {
        const res = await uploadOos(files, 'eventImages');
        if (res.code === 200) {
          this.ruleForm.photograph = res.url;
          if (this.pictureList.length < 6) {
            this.pictureList.push({
              url: res.url,
              uid: files.uid
            });
          }
        } else {
          // 上传图片失败
          this.$message.error(this.$t('fixDutyFine.imageUploadFailed'));
        }
      } catch (e) {
        // 上传图片失败
        this.$message.error(this.$t('fixDutyFine.imageUploadFailed'));
      } finally {
        this.uploadingCount--;
        this.checkUploadComplete();
      }
    },
    // 检查是否所有上传都已完成
    checkUploadComplete() {
      if (this.uploadingCount === 0 && this.loadingBtn) {
        this.loadingBtn = false;
      }
    },
    // 图片上传前
    beforeAvatarUpload(rawFile) {
      // 获取文件扩展名
      const extension = rawFile.name.split('.').pop().toLowerCase();
      // 支持的图片格式
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif'];
      // 检查文件格式是否为图片格式
      if (!allowedExtensions.includes(extension)) {
        this.$message.error(this.$t('fixDutyFine.formatFile'));
      } else {
        // 开始上传时增加计数并显示loading
        this.uploadingCount++;
        this.loadingBtn = true;
      }

      return allowedExtensions.includes(extension);
    },
    // 改变图片选择
    handleChangeFile(file, fileList) {
      console.log(file, fileList);
    },
    handleExceed(file, fileList) {
      if (fileList.length >= 6) {
        this.$message.error(this.$t('fixDutyFine.maxImageUploadLimit'));
        return;
      }
    },
    // 移除触发的钩子
    handleDeleteImgRemove(file, fileList) {
      console.log(file, fileList);
      if (file.uid) {
        const uid = file.uid;
        const findIndex = this.pictureList.findIndex((url) => url.uid === uid);
        console.log(findIndex, 'findIndex');
        this.pictureList.splice(findIndex, 1);
        console.log(this.pictureList, 'this.pictureList');
      }
      if (this.pictureList.length === 0) {
        this.ruleForm.photograph = '';
      }
    },
    // 车牌号
    getVehicleNumber(val) {
      const data = {
        number: val,
        queryType: 1
      };
      vehicleTagNumber(data).then((res) => {
        if (res.code === 200) {
          this.vehicleNumberList = res.data;
        }
      });
    }
  }
};
</script>

<style scoped>
>>> .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

>>> .el-upload-list__item {
  width: 100px;
  height: 100px;
}
</style>
